// extracted by mini-css-extract-plugin
export default {"card":"SupportCard_card__gOI6c","title":"SupportCard_title__X3Usf","text":"SupportCard_text__3Dyc7","btn":"SupportCard_btn__X54HT"};